import { MIN_PASSWORD_LENGTH } from "@tennis-matches/core/utils";
import { normalizeSignupIntent } from "./signup-intent.js";

/**
 * Pure field validation for public registration (step 1).
 * Returns i18n keys — caller maps with `t`.
 *
 * @param {{
 *   email?: string,
 *   password?: string,
 *   password2?: string,
 *   firstName?: string,
 *   lastName?: string,
 *   signupIntent?: string,
 *   consentPrivacy?: boolean,
 *   consentTerms?: boolean,
 * }} fields
 * @returns {{ ok: boolean, errors: Record<string, string> }}
 */
export function validatePublicRegistration(fields = {}) {
  const email = String(fields.email || "")
    .trim()
    .toLowerCase();
  const password = String(fields.password || "");
  const password2 = String(fields.password2 || "");
  const firstName = String(fields.firstName || "").trim();
  const lastName = String(fields.lastName || "").trim();
  /** @type {Record<string, string>} */
  const errors = {};

  if (!email || !email.includes("@")) {
    errors.email = "auth.validation.emailInvalid";
  }
  if (password.length < MIN_PASSWORD_LENGTH) {
    errors.password = "auth.validation.passwordMinLength";
  }
  if (password !== password2) {
    errors.password2 = "auth.validation.passwordMismatch";
  }
  if (!firstName) {
    errors.firstName = "auth.validation.firstNameRequired";
  }
  if (!lastName) {
    errors.lastName = "auth.validation.lastNameRequired";
  }
  if (!normalizeSignupIntent(fields.signupIntent)) {
    errors.signupIntent = "auth.register.signupIntent.errorRequired";
  }
  if (!fields.consentPrivacy) {
    errors.consentPrivacy = "auth.register.consent.errorPrivacyRequired";
  }
  if (!fields.consentTerms) {
    errors.consentTerms = "auth.register.consent.errorTermsRequired";
  }

  return { ok: Object.keys(errors).length === 0, errors };
}
